export const ADJUST_URL = 'https://app.adjust.net.in';
